import CommunityObject from "./CommunityObject";
import User from "./UserObject";
import Tag from "./TagObject";

export default class ScenarioObject extends CommunityObject {
  constructor(scenario) {
    super(ScenarioObject.name);
    this.device_id = Number(scenario.device_id);
    this.uuid_id = String(scenario.uuid_id);
    this.name = String(scenario.name);
    this.description = String(scenario.description);
    this.patient_age = Number(scenario.patient_age);
    this.patient_condition = Number(scenario.patient_condition);
    this.file_size = String(scenario.file_size);
    this.contributed_at = String(scenario.contributed_at);
    this.unicode_language_identifier = String(
      scenario.unicode_language_identifier
    );
    this.num_downloads = Number(scenario.num_downloads);
    this.has_video = Boolean(scenario.has_video);
    this.has_images = Boolean(scenario.has_images);
    this.has_sounds = Boolean(scenario.has_sounds);
    this.has_labs = Boolean(scenario.has_labs);
    this.num_events = Number(scenario.num_events);
    this.num_checklist_items = Number(scenario.num_checklist_items);
    this.duration_in_seconds = Number(scenario.duration_in_seconds);
    this.is_favourited_by_current_user = Boolean(
      scenario.is_favourited_by_current_user
    );
    this.number_favourites = Number(scenario.number_favourites);
    this.tags = [];
    this.is_processed = Boolean(scenario.is_processed);
    this.privacy_level = Number(scenario.privacy_level);
    this.is_publishable = Boolean(scenario.is_publishable);

    if (scenario.contributed_by) {
      this.contributed_by = new User(scenario.contributed_by);
    }
    if (scenario.tags) {
      scenario.tags.forEach(tag => {
        this.tags.push(new Tag(tag));
      });
    }
    this.validate();
  }
  static toJSON() {
    uuid_id: this.uuid_id;
    name: this.name;
    description: this.description;
    patient_age: this.patient_age;
    patient_condition: this.patient_condition;
    file_size: this.file_size;
    contributed_by: this.contributed_by;
    unicode_language_identifier: this.unicode_language_identifier;
    num_downloads: this.num_downloads;
    has_videos: this.has_videos;
    has_images: this.has_images;
    has_sounds: this.has_sounds;
    has_labs: this.has_labs;
    num_events: this.num_events;
    num_checklist_items: this.num_checklist_items;
    duration_in_seconds: this.duration_in_seconds;
    is_favourited_by_current_user: this.is_favourited_by_current_user;
    number_favourites: this.number_favourites;
    tags: this.tags;
    is_processed: this.is_processed;
    privacy_level: this.privacy_level;
    is_publishable: this.is_publishable;
  }
}
